import axios from 'axios'
import { CommonTopographicCodeResponse } from '@/api/services/common/topographic-code/common-topographic-code.dto'
import { CommonParamsWithQuery } from '@/api/resources/common/shared/models/common.models'

class CommonTopographicCodeService {
    async getTopographicCodes(): Promise<CommonTopographicCodeResponse[]> {
        const response = await axios.get<CommonTopographicCodeResponse[]>(`/topographicCodes/`)
        return response.data
    }

    async searchTopographicCodes(params: CommonParamsWithQuery): Promise<CommonTopographicCodeResponse[]> {
        const response = await axios.get<CommonTopographicCodeResponse[]>(`/topographicCodes/search`, { params })
        return response.data
    }
}

export const commonTopographicCodeService = new CommonTopographicCodeService()
